import Request from ".";
import { Routes } from "../constant/api_url";

const LoginRequest = async (formdata) => {
  try {
    const res = await Request.post(Routes.LOGIN, formdata, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json",
        is_prime: 1,
      }
    }); 
    return res?.data;
  } catch (error) {
    throw error;
  }
};
export { LoginRequest };
